import { render } from "./gth2021.vue?vue&type=template&id=856c0834"
const script = {}

import "./gth2021.vue?vue&type=style&index=0&id=856c0834&lang=css"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__